export default __webpack_public_path__ + "static/rocket-130f1e06857cc342c7153e082f1eef1c.png";